import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/content';

const Testimonials = () => {
  return (
    <section
      id="temoignages"
      className="py-16 md:py-24"
      style={{ backgroundColor: '#E9DFCF' }}
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2
            className="text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900 mb-4"
            style={{ letterSpacing: '-0.04em' }}
          >
            Ils nous font confiance
          </h2>
          <p className="text-lg text-gray-600">
            Découvrez les retours d'entrepreneurs qui ont transformé leur quotidien grâce à l'IA.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote icon */}
              <div className="mb-4">
                <Quote className="w-8 h-8 text-blue-200" />
              </div>

              {/* Quote text */}
              <p className="text-gray-700 mb-6 leading-relaxed">
                "{testimonial.quote}"
              </p>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                  loading="lazy"
                  width="48"
                  height="48"
                />
                <div>
                  <p className="font-semibold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="mt-16 rounded-2xl p-8 md:p-12" style={{ backgroundColor: '#1C2E4A' }}>
          <div className="grid sm:grid-cols-3 gap-8 text-center">
            <div>
              <p className="text-4xl font-black text-white mb-2">500+</p>
              <p className="text-blue-100">Entreprises formées</p>
            </div>
            <div>
              <p className="text-4xl font-black text-white mb-2">98%</p>
              <p className="text-blue-100">Taux de satisfaction</p>
            </div>
            <div>
              <p className="text-4xl font-black text-white mb-2">+40%</p>
              <p className="text-blue-100">Productivité moyenne</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
